export enum ProductionReadyEnum {
  JmixUi = 'jmix',
  Python = 'python',
}
